import { useContext, useEffect, useState } from "react";
import SignUpHandler from "../Apihander/signup/signupHandler";
import SidebarContext from "../contexts/MyContext";
import { usePremiumStatus } from "./usePremiumStatus";
import { fetchAndActivate, getValue, activate } from "firebase/remote-config";
import { firebaseApp, remoteConfig } from "../config/firebaseConfig";



export const useMakePayment = () => {
    const { setPremiumLoading, isAnnual, isProductionMode, setIsProductionMode, webPlanDetails, setWebPlanDetails, setUser } = useContext(SidebarContext);
    const { startPolling } = usePremiumStatus();


    const handleMakePaymentOfPremium = async () => {
        setPremiumLoading(true)
        try {
            // Remote Config may send the flag as a string
            const isProduction = isProductionMode === true || isProductionMode === "true";

            const formData = new FormData();
            formData.append('project_code', "1139.2");
            formData.append('period', isAnnual ? 'year' : 'month')

            if (isProduction) {
                // Production mode details
                formData.append('payment_method_id', webPlanDetails?.payment_method_id);
                formData.append('currency', 'USD');
                formData.append('total_amount', isAnnual ? webPlanDetails?.yearly_discounted_price : webPlanDetails?.monthly_price)
            } else {
                // Staging test mode details
                formData.append('payment_method_id', 6);
                formData.append('currency', 'INR');
                formData.append('total_amount', 1)
            }


            const data = await SignUpHandler.doMakePaymentPremium(formData)
            console.log(data)
            const url = data?.data?.data?.url;
            if (url) {
                window.location.href = url;
                // window.open(url, "_blank");
                startPolling()
            }

            setPremiumLoading(false)
        } catch (error) {
            console.error('Error:', error);
            setPremiumLoading(false)
        }
    }

    return { handleMakePaymentOfPremium }
}
